
export const claims = {
  "screen": "FunctionalEntitlements",
  "sections": "ProductBasedFunctionalEntitlements",
  "isJsonReturnObject": true,
 
};

export const getUserDetailsPayload={
  "screen": "Funtional Entitlements",
  "sections": "all",
  "isJsonReturnObject": true
}
